export default __webpack_public_path__ + "static/media/logo_prevenir.d402eae2.svg";